import { StatefullValue } from '@meddev/fe-shared';
import {
    BookingDetailsModel,
    BookingFilterInfoModel,
    BookingInfoSelectedFiltersModel,
    MaskedTimeslotPlaceholdersResponse,
    TimeSlotBookingModel,
    TimeSlotMetadata,
    TimeSlotResultModel,
} from '../../model';

/* eslint-disable @typescript-eslint/no-namespace */
export namespace SelfBookingActions {
    export class SetBookingDetails {
        public static readonly type = '[SelfBookingActions] SetBookingDetails';
        constructor(public readonly bookingDetails: StatefullValue<BookingDetailsModel | null>) {}
    }

    export class SetBookingFilterInfo {
        public static readonly type = '[SelfBookingActions] SetBookingFilterInfo';
        constructor(public readonly bookingfilter: StatefullValue<BookingFilterInfoModel | null>) {}
    }

    export class SetBookingFilters {
        public static readonly type = '[SelfBookingActions] SetBookingFilters';
        constructor(public readonly selectedFilterUuids: BookingInfoSelectedFiltersModel) {}
    }

    export class SetLoadSlotsPreview {
        public static readonly type = '[SelfBookingActions] SetLoadSlotsPreview';
        constructor(public readonly loadSlotsCombinationsCount: number) {}
    }

    export class SetTimeslotResult {
        public static readonly type = '[SelfBookingActions] SetTimeslotResult';
        constructor(public readonly timeslotResult: StatefullValue<TimeSlotResultModel[] | null>) {}
    }

    export class SetLastBookedAllowanceToken {
        public static readonly type = '[SelfBookingActions] SetLastBookedAllowanceToken';
        constructor(public readonly lastBookedAllowanceToken: string) {}
    }

    export class SetBookingFilterPlaceholders {
        public static readonly type = '[SelfBookingActions] SetBookingFilterPlaceholders';
        constructor(public readonly bookingFilterPlaceholders: StatefullValue<MaskedTimeslotPlaceholdersResponse | null>) {}
    }

    export class SetConfirmationSlot {
        public static readonly type = '[SelfBookingActions] SetConfirmationSlot';
        constructor(
            public readonly slot: TimeSlotBookingModel,
            public readonly metadata: TimeSlotMetadata,
        ) {}
    }

    export class ClearConfirmationSlot {
        public static readonly type = '[SelfBookingActions] ClearConfirmationSlot';
    }

    export class ResetState {
        public static readonly type = '[SelfBookingActions] ResetState';
    }
}
